module.exports = __webpack_public_path__ + "img/31.084922f5.png";